import React from 'react';

const StepTwoProject = ({ data, onChange, errors }) => {
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    onChange({ [name]: value });
    
    // Clear error when user starts typing
    if (errors[name]) {
      errors[name] = '';
    }
  };

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Project Type */}
        <div>
          <label htmlFor="projectType" className="block text-sm font-medium mb-2" style={{color: '#3E3E3E'}}>
            Project Type *
          </label>
          <select
            id="projectType"
            name="projectType"
            value={data.projectType}
            onChange={handleInputChange}
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-colors appearance-none bg-white ${
              errors.projectType ? 'border-red-500' : 'border-stone-300'
            }`}
            style={{focusRingColor: '#C8A96A'}}
          >
            <option value="">Select project type</option>
            <option value="home-interior">Home Interior</option>
            <option value="office-interior">Office Interior</option>
            <option value="modular-kitchen">Modular Kitchen</option>
            <option value="renovation">Renovation</option>
          </select>
          {errors.projectType && (
            <p className="mt-1 text-sm text-red-500">{errors.projectType}</p>
          )}
        </div>

        {/* Property Type */}
        <div>
          <label htmlFor="propertyType" className="block text-sm font-medium mb-2" style={{color: '#3E3E3E'}}>
            Property Type *
          </label>
          <select
            id="propertyType"
            name="propertyType"
            value={data.propertyType}
            onChange={handleInputChange}
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-colors appearance-none bg-white ${
              errors.propertyType ? 'border-red-500' : 'border-stone-300'
            }`}
            style={{focusRingColor: '#C8A96A'}}
          >
            <option value="">Select property type</option>
            <option value="1bhk">1BHK</option>
            <option value="2bhk">2BHK</option>
            <option value="3bhk">3BHK</option>
            <option value="villa">Villa</option>
            <option value="office">Office</option>
          </select>
          {errors.propertyType && (
            <p className="mt-1 text-sm text-red-500">{errors.propertyType}</p>
          )}
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Area Size */}
        <div>
          <label htmlFor="areaSize" className="block text-sm font-medium mb-2" style={{color: '#3E3E3E'}}>
            Area Size (sq ft) *
          </label>
          <input
            type="number"
            id="areaSize"
            name="areaSize"
            value={data.areaSize}
            onChange={handleInputChange}
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-colors ${
              errors.areaSize ? 'border-red-500' : 'border-stone-300'
            }`}
            placeholder="1200"
            min="100"
            style={{focusRingColor: '#C8A96A'}}
          />
          {errors.areaSize && (
            <p className="mt-1 text-sm text-red-500">{errors.areaSize}</p>
          )}
        </div>

        {/* Budget Range */}
        <div>
          <label htmlFor="budgetRange" className="block text-sm font-medium mb-2" style={{color: '#3E3E3E'}}>
            Budget Range *
          </label>
          <select
            id="budgetRange"
            name="budgetRange"
            value={data.budgetRange}
            onChange={handleInputChange}
            className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-primary focus:border-transparent transition-colors appearance-none bg-white ${
              errors.budgetRange ? 'border-red-500' : 'border-stone-300'
            }`}
            style={{focusRingColor: '#C8A96A'}}
          >
            <option value="">Select budget range</option>
            <option value="1-3-lakh">1–3 Lakh</option>
            <option value="3-5-lakh">3–5 Lakh</option>
            <option value="5-10-lakh">5–10 Lakh</option>
            <option value="10l-plus">10L+</option>
          </select>
          {errors.budgetRange && (
            <p className="mt-1 text-sm text-red-500">{errors.budgetRange}</p>
          )}
        </div>
      </div>

      {/* Project Info Cards */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div className="p-4 rounded-lg border border-stone-200 hover:border-primary transition-colors cursor-pointer">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{backgroundColor: '#C8A96A'}}>
              <span className="material-symbols-outlined text-white">home</span>
            </div>
            <div>
              <h4 className="font-medium" style={{color: '#3E3E3E'}}>Home Interior</h4>
              <p className="text-sm text-stone-600">Complete home transformation</p>
            </div>
          </div>
        </div>

        <div className="p-4 rounded-lg border border-stone-200 hover:border-primary transition-colors cursor-pointer">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{backgroundColor: '#C8A96A'}}>
              <span className="material-symbols-outlined text-white">apartment</span>
            </div>
            <div>
              <h4 className="font-medium" style={{color: '#3E3E3E'}}>Office Interior</h4>
              <p className="text-sm text-stone-600">Professional workspace design</p>
            </div>
          </div>
        </div>

        <div className="p-4 rounded-lg border border-stone-200 hover:border-primary transition-colors cursor-pointer">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{backgroundColor: '#C8A96A'}}>
              <span className="material-symbols-outlined text-white">kitchen</span>
            </div>
            <div>
              <h4 className="font-medium" style={{color: '#3E3E3E'}}>Modular Kitchen</h4>
              <p className="text-sm text-stone-600">Modern kitchen solutions</p>
            </div>
          </div>
        </div>

        <div className="p-4 rounded-lg border border-stone-200 hover:border-primary transition-colors cursor-pointer">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{backgroundColor: '#C8A96A'}}>
              <span className="material-symbols-outlined text-white">construction</span>
            </div>
            <div>
              <h4 className="font-medium" style={{color: '#3E3E3E'}}>Renovation</h4>
              <p className="text-sm text-stone-600">Upgrade existing spaces</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepTwoProject;
